import { render, staticRenderFns } from "./CAppSelector.vue?vue&type=template&id=05dc148b&scoped=true&"
import script from "./CAppSelector.vue?vue&type=script&lang=js&"
export * from "./CAppSelector.vue?vue&type=script&lang=js&"
import style0 from "./CAppSelector.vue?vue&type=style&index=0&id=05dc148b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc148b",
  null
  
)

export default component.exports